import { Injectable } from '@angular/core';
import { resolveBlobDeliveryUrl } from '@shared/utils/blob-delivery-url';
import { FloorPlan } from '@map/models';
import { BaseService } from '@shared/services/base.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FloorPlanService extends BaseService {
    constructor() {
        super();
        this.setApiName('FloorPlans');
    }

    getImageBlob(imageUrl: string) {
        return this.httpClient.get(resolveBlobDeliveryUrl(imageUrl, environment.apiUrl), { responseType: 'blob' });
    }

    uploadImage(floorPlanId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.httpClient.post(`${this.apiUrl()}/${floorPlanId}/image`, formData).pipe(
            catchError((error) => {
                return this.handleError(error);
            })
        );
    }

    override create<T>(data: any): Observable<T> {
        // Copying a plan uploads its image separately; never persist a short-lived link.
        const { imageUrl, secureImageUrl, ...rest } = data;
        return super.create<T>(rest);
    }

    override patch<T>(id: number, data: any): Observable<T> {
        // Strip server-managed fields before sending to avoid storing expiring imageUrl as permanent reference
        const { imageUrl, secureImageUrl, ...rest } = data;
        return super.patch<T>(id, rest);
    }

    override get<T>(id: number, appendToUrl?: string): Observable<T> {
        return super.get<T>(id, appendToUrl).pipe(
            map((response: any) => {
                return {
                    ...response,
                    secureImageUrl: response.imageUrl, // Assuming imageUrl is the URL to the image
                };
            })
        );
    }

    override mapResponseToObject<T>(response: any): T {
        const floorPlan = new FloorPlan({ ...response, imageUrl: resolveBlobDeliveryUrl(response.imageUrl, environment.apiUrl) }) as any;
        return floorPlan;
    }
    override mapArrayResponseToObject<T>(response: any): T {
        return response.map((responseJson: any) => this.mapResponseToObject(responseJson));
    }
}
